export default __webpack_public_path__ + "static/media/reports-23.3d10a51b.png";